import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7b6c5fe6"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spinner-bg" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "spinner" })
], -1))
const _hoisted_2 = [
  _hoisted_1
]


export default /*#__PURE__*/_defineComponent({
  __name: 'Spinner',
  props: {
  visible: { type: Boolean, default: false },
  isAbsolute: { type: Boolean, default: false },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (__props.visible)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass([
      'spinner-container w-100',
      { absolute: __props.isAbsolute, 'flex-centered py-5': !__props.isAbsolute },
    ])
      }, _hoisted_2, 2))
    : _createCommentVNode("", true)
}
}

})